
var Model = require("../types/Model.js");
var xtend = require("xtend");
// eslint-disable-next-line node/no-missing-require
const AsyncStorage = require("@react-native-async-storage/async-storage").default;


var STORAGE_PREFIX = "managed_section_views_";

module.exports = Model({
	name: "managedsectionupdateviews",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	reset: reset,
	load: load,
});

function init() {
	this.reset();
}

function listeners() {
	return {
		"managedaccount:updated": track,
		"managedactivegroupformsubmission:viewed": update,
		"managedreminders:viewed": update,
		"managedurgencycontacts:newcontact": update,
		"managedforms:newnote": update,
		"managedatouchaway:newatouchawaysettings": update,
		"managedpreferences:newsettings": update,
		"managedcontacts:newcontact": update,
		"managedbracelet:newbraceletsettings": update,
		"managedcontactrequests:newcontactrequest": update,
		"managedurgencypreferences:newurgencypreferences": update,
		"managedmanagerrequests:viewed": update,
		"managedaccountinvites:viewing": update,
	};
}

function triggers() {
	return {
		"update": update
	};
}

function track(managedaccount) {
	if (!managedaccount.open)
		return this.reset();

	var who = managedaccount.data._id;

	if (who === this._who) return;

	this.reset();

	this._who = who;

	this.load();
}

function reset() {
	this._who = null;
	this.push({});
}

function load() {
	var who = this._who;
	if (!who) return;
	return AsyncStorage.getItem(STORAGE_PREFIX + who).then(function (raw) {
		if (!raw) raw = "{}";
		var parsed = {};
		try {
			parsed = JSON.parse(raw);
		} catch (e) {
			// Whatever
		}
		this.push(parsed);
	}.bind(this));

}

function update(data) {
	console.log("Updating", data);

	var who = data.who;
	var section = data.section;
	var timestamp = data.timestamp;

	var existing = this.data;
	var updates = {};
	updates[section] = timestamp;

	var updated = xtend(existing, updates);

	AsyncStorage.setItem(STORAGE_PREFIX + who, JSON.stringify(updated));

	if (who === this._who)
		this.push(updated);
}
